import React from "react";

function Github() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="85.333"
      height="85.333"
      version="1"
      viewBox="0 0 64 64"
      className="github"
    >
      <path
        id="github"
        d="M245 631c-92-24-173-91-216-176-34-69-34-187 0-262C55 135 132 57 185 34c49-20 55-18 55 21 0 33-2 35-35 35-35 0-42 5-90 66-44 56-24 61 34 9 45-41 73-44 96-12 14 21 14 22-7 30-57 21-86 40-101 67-22 36-23 128-1 158 8 12 12 27 9 32-10 16 5 70 18 70 7 0 24-6 38-14 32-16 202-15 242 2 16 7 32 12 37 12 11 0 23-56 15-70-3-5 1-20 9-32 22-31 21-126-1-158-24-35-43-48-86-60-32-9-36-13-27-30 5-10 10-46 10-79 0-35 4-61 10-61 55 0 167 96 201 173 34 75 34 193 0 262-32 64-93 124-155 153-53 25-160 37-211 23z"
        transform="matrix(.1 0 0 -.1 0 64)"
      ></path>
    </svg>
  );
}

export default Github;